import { SEARCH_REPOSITORIES } from "../actions/types";

const initialState = {
  repositoryData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SEARCH_REPOSITORIES:
      return {
        ...state,
        repositoryData: action.payload,
      };
    default:
      return state;
  }
}
